import React, {useContext,useRef,useState} from 'react'
import {Card, Button, Alert} from '@mui/material'
import { formularioContext } from '../contextos/FormularioContext'
import {Nacionalidad} from '../componentes/Nacionalidad'
import {Fecha} from '../componentes/Fecha'
import {useHelper} from '../hooks/useHelper'
import {SexosSelect} from '../componentes/SexosSelect'
import {Sexo} from './Sexo'
import {Ubicacion} from './Ubicacion'
import { TextField } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
// o también:
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

export const DatosPersonales = ({
    handleChangeApellidoDinamico,
    handleChangeDocumentoDinamico,
    handleChangeSexoDinamico,
    handleChangeProvinciaDinamico,
    datosOkDinamico,handleChangeEmailDinamico,handleChangeEdadDinamico,
    handleChangeNombreDinamico,datosDinamicos})=>{

    const {errorMail,datos} = useContext(formularioContext)
    const dniRef = useRef(null)
    const [valorDNIref,setValorDNIref] = useState(null)
        
    const manageOnBlurDNI =(e)=>{
        console.log(`Validar este DNI: ${e.target.value}`)
    }
    const manageOnFocusDNI =(e)=>{
        console.log(`Validar este DNI: ${e.target.value}`)
    }

    // return <Card>
    // <div className="mt-2">
    //             <label htmlFor="dp-documento" className="block text-sm font-medium text-gray-700">Nro. de documento</label>
    //             <Input
    //                 id="dp-documento"
    //                 type="text"
    //                 autoFocus
    //                 maxLength={9}
    //                 value={datosDinamicos?.documento}
    //                 onBlur={manageOnBlurDNI}
    //                 onFocus={manageOnFocusDNI}
    //                 ref={dniRef}
    //                 onChange={handleChangeDocumentoDinamico}
    //                 className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-300"
    //             />
    //     </div>

    //     <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
    //         <div className="mt-2">
    //             <label htmlFor="dp-nombre" className="block text-sm font-medium text-gray-700">Nombre</label>
    //             <Input
    //                 id="dp-nombre"
    //                 type="text"
    //                 maxLength={25}
    //                 value={datosDinamicos?.nombre}
    //                 onChange={handleChangeNombreDinamico}
    //                 className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-300"
    //             />
    //         </div>
    //         <div className="mt-2">
    //             <label htmlFor="dp-apellido" className="block text-sm font-medium text-gray-700">Apellido</label>
    //             <Input
    //                 id="dp-apellido"
    //                 type="text"
    //                 maxLength={25}
    //                 value={datosDinamicos?.apellido}
    //                 onChange={handleChangeApellidoDinamico}
    //                 className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-300"
    //             />
    //         </div>
    //     </div>

    //     <div className="grid grid-cols-1 mt-4">
    //         <div className="mt-2">
    //             <Sexo sexo={datosDinamicos?.sexo} handleChangeSexo={handleChangeSexoDinamico} />
    //         </div>
    //     </div>

    //     <div className="mt-4">
    //         <label htmlFor="dp-edad" className="block text-sm font-medium text-gray-700">Edad</label>
    //         <Input
    //             id="dp-edad"
    //             type="text"
    //             maxLength={2}
    //             value={datosDinamicos?.edad}
    //             onChange={handleChangeEdadDinamico}
    //             className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-300"
    //         />
    //     </div>

    //     <div className="mt-4">
    //         <Ubicacion id_provincia={datosDinamicos?.id_provincia} handleChangeProvincia={handleChangeProvinciaDinamico} />
    //     </div>

    //     <div className="mt-4">
    //         <label htmlFor="con-email" className="block text-sm font-medium text-gray-700">E-mail</label>
    //         <Input
    //             id="con-email"
    //             type="email"
    //             maxLength={200}
    //             placeholder="nombre@ejemplo.com"
    //             value={datosDinamicos?.email}
    //             onChange={handleChangeEmailDinamico}
    //             className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-300"
    //         />
    //         {/* errorMail(datosDinamicos.email) && <p className="text-red-500">{errorMail(datosDinamicos.email)}</p> */}
    //     </div>


    //     {!datosOkDinamico()[0] && <Alert variant="outlined" severity={datosOkDinamico()[0]? 'info' : 'error'}>
    //                 {datosOkDinamico()[1]}
    //     </Alert>}
    //     </Card>
return <Card style={{maxWidth:'500px', background: '#fbfbfb', padding: '2px', borderWidth: '1px', borderColor: '#ddd', borderStyle: 'solid' }}>
  <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', padding: '1rem' }}>
    <TextField
      id="dp-documento"
      label="Nro. de documento"
      autoFocus
      inputProps={{ maxLength: 9 }}
      value={datosDinamicos?.documento}
      onBlur={manageOnBlurDNI}
      onFocus={manageOnFocusDNI}
      inputRef={dniRef}
      onChange={handleChangeDocumentoDinamico}
      variant="filled"
      fullWidth
      style={{ backgroundColor: '#fff' }}
    />

    <TextField
      id="dp-nombre"
      label="Nombre"
      inputProps={{ maxLength: 25 }}
      value={datosDinamicos?.nombre}
      onChange={handleChangeNombreDinamico}
      variant="filled"
      fullWidth
      style={{ backgroundColor: '#fff' }}
    />

    <TextField
      id="dp-apellido"
      label="Apellido"
      inputProps={{ maxLength: 25 }}
      value={datosDinamicos?.apellido}
      onChange={handleChangeApellidoDinamico}
      variant="filled"
      fullWidth
      style={{ backgroundColor: '#fff' }}
    />

    <Sexo
      sexo={datosDinamicos?.sexo}
      handleChangeSexo={handleChangeSexoDinamico}
    />

    <TextField
      id="dp-edad"
      label="Edad"
      inputProps={{ maxLength: 2 }}
      value={datosDinamicos?.edad}
      onChange={handleChangeEdadDinamico}
      variant="filled"
      fullWidth
      style={{ backgroundColor: '#fff' }}
    />

    <Ubicacion
      id_provincia={datosDinamicos?.id_provincia}
      handleChangeProvincia={handleChangeProvinciaDinamico}
    />

    <TextField
      id="con-email"
      type="email"
      label="E-mail"
      placeholder="nombre@ejemplo.com"
      inputProps={{ maxLength: 200 }}
      value={datosDinamicos?.email}
      onChange={handleChangeEmailDinamico}
      variant="filled"
      fullWidth
      style={{ backgroundColor: '#fff' }}
    />

    {/* {!datosOkDinamico()[0] && (
      <Alert severity="error" variant="outlined">
        {datosOkDinamico()[1]}
      </Alert>
    )} */}

        {/* {!datosOkDinamico()[0] && (
            <CancelIcon color="error" />
    )}
{datosOkDinamico()[0] && (
            <CheckCircleIcon color="success" />
    )} */}


    {/* <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem', paddingTop: 4, paddingBottom: 4 }}>
      <Button
        variant="contained"
        color="primary"
        onClick={iniciarGrabarDinamico}
      >
        Aceptar
      </Button>

      <Button
        variant="text"
        onClick={limpiarDinamico}
      >
        Cancelar
      </Button>
    </div> */}
  </div>
</Card>
}